import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthContextProvider } from './context/AuthContext';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './Urls';

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const rawPosthogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;
const posthogHost = rawPosthogHost?.replace(/\/ingest\/?$/, '/metrics');

if (posthogKey && posthogHost) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    person_profiles: 'identified_only',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const appTree = (
  <PostHogProvider client={posthog}>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </PostHogProvider>
);

root.render(
  GOOGLE_CLIENT_ID ? (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      {appTree}
    </GoogleOAuthProvider>
  ) : (
    appTree
  )
);
